import axios from "axios"
import type {
    EntityField,
    FieldWithSelfAsSubfield,
    AccessField,
    Config,
    UserDefaultFields,
    EntityDefaultFields,
    Operation,
    AccessItem,
} from "../coreTypes/config"
import { DesignerModel } from "./DesignerModel"
import { getPlural } from "mypluralize"
import {
    cleanInputNameStartingUpper,
    getAllAccessFields,
    isFieldsMatch,
    isMandatoryField,
    getSubMandatoryFieldNames,
    getMandatoryAccessFieldsOfParentField,
    removeOperationAllFields,
    getAllAccessFieldsOfParentField,
    getEntityField,
    fieldsWithOperation,
    setOperationAllFields,
    cleanInputNameStartingLower,
} from "../helpers/functions"
import { isEqual } from "lodash"

export const designerMachine = DesignerModel.createMachine(
    {
        /** @xstate-layout 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 */
        id: "designer",

        // Local context for entire machine
        context: DesignerModel.initialContext,

        // Initial state
        initial: "none",

        on: {
            UPDATE_NOTIFICATIONS_API: {
                actions: DesignerModel.assign({ notificationsApi: (ctx, e) => e.notificationsApi }),
            },
        },

        // States
        states: {
            none: {
                on: {
                    FETCH: {
                        target: "globalLoading",
                        actions: DesignerModel.assign({
                            projectId: (_, e) => e.projectId,
                            sessionId: (_, e) => e.sessionId,
                        }),
                    },
                },
            },
            globalLoading: {
                type: "atomic",
                invoke: {
                    id: "designerMachine-getProject",
                    src: "getProject",
                },
                on: {
                    FETCHED: {
                        target: "designer",
                        actions: DesignerModel.assign((_, e) => {
                            return {
                                project: e.project,
                                projectConfig: e.project.latestConfiguration ?? {
                                    apiVersion: "1",
                                    createdAt: new Date(),
                                    users: [
                                        {
                                            groupName: "Admin",
                                            invitable: false,
                                            signupable: true,
                                            userData: {
                                                trackChanges: false,
                                                defaultFields: {
                                                    _id: "USER_ID",
                                                    createdAt: "TIME",
                                                    updatedAt: "TIME",
                                                    createdBy: "USER_ID",
                                                    email: "EMAIL",
                                                    invitedBy: "USER_ID",
                                                    status: "USER_STATUS",
                                                },
                                                fields: [
                                                    {
                                                        name: "fullName",
                                                        description: "Full name of the admin account holder",
                                                        type: "STRING",
                                                        mutable: true,
                                                        mandatory: true,
                                                        isArray: false,
                                                    },
                                                ],
                                                access: [
                                                    {
                                                        type: "USERGROUP",
                                                        rule: {
                                                            type: "ANY",
                                                            name: "",
                                                            description: "",
                                                        },
                                                        fields: "ALL",
                                                        userGroupName: "Admin",
                                                    },
                                                ],
                                            },
                                            description: "Administartion user has full control of project application.",
                                        },
                                    ],
                                    entities: [],
                                    subObjects: {},
                                    enums: {},
                                },
                            }
                        }),
                    },
                    ERROR: { target: "error" },
                },
            },
            error: {
                on: {
                    TRY_AGAIN: {
                        target: "globalLoading",
                    },
                },
            },

            designer: {
                initial: "users",
                states: {
                    // Users related logic
                    users: {
                        on: {
                            ENTITIES: { target: "entities", actions: "trackAction" },
                            SUBOBJECTS: { target: "subobjects", actions: "trackAction" },
                            ENUMS: { target: "enums", actions: "trackAction" },
                            DEPLOY_VERSION: { target: ".deployingVersion", actions: "trackAction" },
                        },
                        initial: "observeUserGroupsList",
                        states: {
                            observeUserGroupsList: {
                                on: {
                                    USER_FORM: {
                                        target: "userForm",
                                        // Takes event object from event above and assigns value to context of model
                                        actions: [
                                            DesignerModel.assign({
                                                userForm: (context, event) =>
                                                    event.user
                                                        ? {
                                                              user: JSON.parse(JSON.stringify(event.user)),
                                                              originalUser: JSON.parse(JSON.stringify(event.user)),
                                                          }
                                                        : context.projectConfig.users.findIndex((u) => u.groupName == "Admin") != -1
                                                          ? {
                                                                user: {
                                                                    ...JSON.parse(JSON.stringify(DesignerModel.initialContext.userForm.user)),
                                                                    userData: {
                                                                        ...JSON.parse(JSON.stringify(DesignerModel.initialContext.userForm.user))
                                                                            .userData,
                                                                        access: [
                                                                            {
                                                                                type: "USERGROUP",
                                                                                rule: {
                                                                                    type: "ANY",
                                                                                    name: "",
                                                                                    description: "",
                                                                                },
                                                                                fields: "ALL",
                                                                                userGroupName: "Admin",
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                                originalUser: undefined,
                                                            }
                                                          : {
                                                                user: JSON.parse(JSON.stringify(DesignerModel.initialContext.userForm.user)),
                                                                originalUser: undefined,
                                                            },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                            userForm: {
                                type: "parallel",
                                on: {
                                    CHANGE_USER_GROUP_NAME: {
                                        actions: [
                                            DesignerModel.assign({
                                                userForm: (context, event) => {
                                                    const newUser = context.userForm.user
                                                    const originalUser = context.userForm.originalUser
                                                    newUser.userData.access.forEach((ua) => {
                                                        if (ua.userGroupName === originalUser?.groupName) {
                                                            ua.userGroupName = cleanInputNameStartingUpper(event.groupName)
                                                        }
                                                    })
                                                    return {
                                                        ...context.userForm,
                                                        user: { ...newUser, groupName: cleanInputNameStartingUpper(event.groupName) },
                                                    }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    CHANGE_USER_GROUP_DESCRIPTION: {
                                        actions: [
                                            DesignerModel.assign({
                                                userForm: (context, event) => ({
                                                    ...context.userForm,
                                                    user: { ...context.userForm.user, description: event.description },
                                                }),
                                            }),
                                        ],
                                    },
                                    SWITCH_USER_GROUP_TRACK_CHANGES: {
                                        actions: [
                                            DesignerModel.assign({
                                                userForm: (context) => ({
                                                    ...context.userForm,
                                                    user: {
                                                        ...context.userForm.user,
                                                        userData: {
                                                            ...context.userForm.user.userData,
                                                            trackChanges: !context.userForm.user.userData.trackChanges,
                                                        },
                                                    },
                                                }),
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    SAVE_USER: {
                                        target: "savingConfig",
                                        actions: [
                                            DesignerModel.assign({
                                                projectConfig: (context) => {
                                                    const entities = context.projectConfig.entities
                                                    const users = context.projectConfig.users
                                                    const subObjects = context.projectConfig.subObjects
                                                    const newUser = context.userForm.user
                                                    const originalUser = context.userForm.originalUser

                                                    if (originalUser) {
                                                        users.forEach((user) => {
                                                            user.userData.access.forEach((ua) => {
                                                                if (ua.userGroupName === originalUser?.groupName) {
                                                                    ua.userGroupName = newUser.groupName
                                                                }
                                                            })
                                                        })

                                                        subObjects &&
                                                            Object.values(subObjects).forEach((sb) => {
                                                                sb.fields.forEach((sbf) => {
                                                                    if (sbf?.connectedEntityName === originalUser?.groupName) {
                                                                        sbf.connectedEntityName = newUser.groupName
                                                                    }
                                                                })
                                                            })

                                                        newUser.userData.fields.forEach((uf) => {
                                                            if (uf?.connectedEntityName === originalUser?.groupName) {
                                                                uf.connectedEntityName = newUser.groupName
                                                            }
                                                        })

                                                        entities.forEach((entity) => {
                                                            entity.access.forEach((ea) => {
                                                                if (ea.userGroupName === originalUser?.groupName) {
                                                                    ea.userGroupName = newUser.groupName
                                                                }
                                                            })
                                                            for (let i = entity.fields.length; i >= 0; i--) {
                                                                if (entity.fields[i]?.connectedEntityName === originalUser?.groupName) {
                                                                    if (entity.fields[i].connectedEntityRemoteFieldName) {
                                                                        entity.fields.splice(i, 1)
                                                                    } else {
                                                                        entity.fields[i].connectedEntityName = newUser.groupName
                                                                    }
                                                                }
                                                            }
                                                        })
                                                    }
                                                    for (const field of newUser.userData.fields) {
                                                        if (field.connectionUnderlyingField) {
                                                            let remoteConnectionExists = false
                                                            const remoteEntity = entities.find((e) => e.entityName == field.connectedEntityName)
                                                            let newName = getPlural(newUser.groupName)
                                                            newName =
                                                                newName.slice(0, 1).toLowerCase() +
                                                                newName.slice(1) +
                                                                "By" +
                                                                field.name.substring(0, 1).toUpperCase() +
                                                                field.name.substring(1)
                                                            const newField = {
                                                                name: newName,
                                                                type: "CONNECTION_CONTAINS",
                                                                connectedEntityName: newUser.groupName,
                                                                connectedEntityRemoteFieldName: field.connectionUnderlyingField.name,
                                                            } as EntityField

                                                            if (remoteEntity) {
                                                                for (const rField of remoteEntity.fields) {
                                                                    if (rField.connectedEntityName == newUser.groupName && rField.name == newName) {
                                                                        remoteConnectionExists = true
                                                                        break
                                                                    }
                                                                }
                                                                if (!remoteConnectionExists) {
                                                                    remoteEntity.fields.push(newField)
                                                                }
                                                            } else {
                                                                const remoteUser = users.find((u) => u.groupName == field.connectedEntityName)
                                                                if (remoteUser) {
                                                                    for (const rField of remoteUser.userData.fields) {
                                                                        if (
                                                                            rField.connectedEntityName == newUser.groupName &&
                                                                            rField.name == newName
                                                                        ) {
                                                                            remoteConnectionExists = true
                                                                            break
                                                                        }
                                                                    }
                                                                    if (!remoteConnectionExists) {
                                                                        remoteUser.userData.fields.push(newField)
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }

                                                    if (!context.userForm.originalUser) {
                                                        users.push(newUser)
                                                    } else {
                                                        users.splice(
                                                            users.findIndex((user) => user.groupName === context.userForm.originalUser?.groupName),
                                                            1,
                                                            newUser
                                                        )
                                                    }

                                                    return {
                                                        ...context.projectConfig,
                                                        users,
                                                        entities,
                                                    }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    RESET_USER: {
                                        actions: [
                                            DesignerModel.assign({
                                                userForm: (context) => {
                                                    if (!context.userForm.originalUser)
                                                        return {
                                                            user: JSON.parse(JSON.stringify(DesignerModel.initialContext.userForm.user)),
                                                            originalUser: undefined,
                                                        }
                                                    else return { ...context.userForm, user: context.userForm.originalUser }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    DELETE_USER: {
                                        target: "savingConfig",
                                        actions: [
                                            DesignerModel.assign({
                                                projectConfig: (context) => {
                                                    if (!context.userForm.originalUser) return { ...context.projectConfig }

                                                    const groupName = context.userForm.originalUser!.groupName
                                                    const users = context.projectConfig.users
                                                    users.splice(
                                                        users.findIndex((user) => user.groupName === groupName),
                                                        1
                                                    )

                                                    for (const u of users) {
                                                        for (let ufi = 0; ufi < u.userData.fields.length; ufi++) {
                                                            const uf = u.userData.fields[ufi]
                                                            if (uf.connectedEntityName == groupName) {
                                                                for (const ua of u.userData.access) {
                                                                    if (ua.fields !== "ALL") {
                                                                        for (let uaf = ua.fields.length - 1; uaf >= 0; uaf--) {
                                                                            if (ua.fields[uaf].fieldName == uf.name) {
                                                                                ua.fields.splice(uaf, 1)
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                u.userData.fields.splice(ufi, 1)
                                                            }
                                                        }
                                                    }
                                                    const entities = context.projectConfig.entities
                                                    for (const e of entities) {
                                                        for (let efi = 0; efi < e.fields.length; efi++) {
                                                            const ef = e.fields[efi]
                                                            if (ef.connectedEntityName == groupName) {
                                                                for (const ea of e.access) {
                                                                    if (ea.fields !== "ALL") {
                                                                        for (let eaf = ea.fields.length - 1; eaf >= 0; eaf--) {
                                                                            if (ea.fields[eaf].fieldName == ef.name) {
                                                                                ea.fields.splice(eaf, 1)
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                e.fields.splice(efi, 1)
                                                            }
                                                        }
                                                    }
                                                    const subObjects = context.projectConfig.subObjects
                                                    if (subObjects) {
                                                        for (const sk of Object.keys(subObjects)) {
                                                            const s = subObjects[sk]
                                                            for (let sfi = s.fields.length - 1; sfi >= 0; sfi--) {
                                                                const sf = s.fields[sfi]
                                                                if (sf.connectedEntityName == groupName) {
                                                                    // TODO: ideally need to scan all users, entities, subobjects where this subobject is used as field and from access.fields remove subobject's field
                                                                    s.fields.splice(sfi, 1)
                                                                }
                                                            }
                                                        }
                                                    }

                                                    return {
                                                        ...context.projectConfig,
                                                        users: users,
                                                        entities: entities,
                                                        subObjects: subObjects,
                                                    }
                                                },
                                                userForm: {
                                                    user: JSON.parse(JSON.stringify(DesignerModel.initialContext.userForm.user)),
                                                    originalUser: undefined,
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    CANCEL_USER: {
                                        target: "observeUserGroupsList",
                                        actions: [
                                            DesignerModel.assign({
                                                userForm: {
                                                    user: JSON.parse(JSON.stringify(DesignerModel.initialContext.userForm.user)),
                                                    originalUser: undefined,
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                                states: {
                                    fields: {
                                        initial: "observeFields",
                                        states: {
                                            observeFields: {
                                                on: {
                                                    FIELD_FORM: {
                                                        target: "fieldForm",
                                                        actions: [
                                                            DesignerModel.assign({
                                                                fieldForm: (_, event) => {
                                                                    return event.field
                                                                        ? {
                                                                              field: JSON.parse(JSON.stringify(event.field)),
                                                                              originalField: JSON.parse(JSON.stringify(event.field)),
                                                                          }
                                                                        : {
                                                                              field: JSON.parse(
                                                                                  JSON.stringify(DesignerModel.initialContext.fieldForm.field)
                                                                              ),
                                                                              originalField: undefined,
                                                                          }
                                                                },
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                },
                                            },
                                            fieldForm: {
                                                on: {
                                                    CHANGE_FIELD_NAME: {
                                                        actions: ["changeFieldName", "trackAction"],
                                                    },
                                                    RESET_FIELD: {
                                                        actions: ["resetField", "trackAction"],
                                                    },
                                                    CANCEL_FIELD: {
                                                        target: "observeFields",
                                                        actions: "trackAction",
                                                    },
                                                    CHANGE_FIELD_DESCRIPTION: {
                                                        actions: ["changeFieldDescription"],
                                                    },
                                                    CHANGE_FIELD_TYPE: {
                                                        actions: ["changeFieldType", "trackAction"],
                                                    },
                                                    SWITCH_MANDATORY: {
                                                        actions: ["switchMandatory", "trackAction"],
                                                    },
                                                    SWITCH_ISARRAY: {
                                                        actions: ["switchIsArray", "trackAction"],
                                                    },
                                                    SWITCH_MUTABLE: {
                                                        actions: ["switchMutable", "trackAction"],
                                                    },
                                                    CHANGE_CONNECTION_UNDERLYING_FIELD_NAME: {
                                                        actions: ["changeConnectionUnderlyingFieldName", "trackAction"],
                                                    },
                                                    SET_REMOTE_FIELD_NAME: {
                                                        actions: ["setRemoteFieldName", "trackAction"],
                                                    },
                                                    SWITCH_UNDERLYING_MANDATORY: {
                                                        actions: ["switchUnderlyingMandatory", "trackAction"],
                                                    },
                                                    SWITCH_UNDERLYING_ISARRAY: {
                                                        actions: ["switchUnderlyingIsArray", "trackAction"],
                                                    },
                                                    SWITCH_UNDERLYING_MULTABLE: {
                                                        actions: ["switchUnderlyingMutable", "trackAction"],
                                                    },
                                                    // Unique only for user fields
                                                    SAVE_FIELD: {
                                                        target: "observeFields",
                                                        actions: [
                                                            DesignerModel.assign({
                                                                userForm: (context) => {
                                                                    const fields = context.userForm.user.userData.fields

                                                                    if (!context.fieldForm.originalField) {
                                                                        fields.push(context.fieldForm.field)
                                                                    } else {
                                                                        fields.splice(
                                                                            fields.findIndex(
                                                                                (field) => field.name === context.fieldForm.originalField?.name
                                                                            ),
                                                                            1,
                                                                            context.fieldForm.field
                                                                        )
                                                                    }

                                                                    if (context.fieldForm.field.mandatory) {
                                                                        if (context.fieldForm.field.subObjectName) {
                                                                            const subFieldNames = getSubMandatoryFieldNames(
                                                                                context.projectConfig,
                                                                                fields,
                                                                                context.fieldForm.field.name
                                                                            )

                                                                            const newFields = subFieldNames.map((fn) => ({
                                                                                fieldName: context.fieldForm.field.name,
                                                                                operations: ["CREATE" as Operation],
                                                                                subfield: { fieldName: fn },
                                                                            }))

                                                                            context.userForm.user.userData.access.forEach((accessObj) => {
                                                                                newFields.forEach((nf) => {
                                                                                    if (
                                                                                        Array.isArray(accessObj.fields) &&
                                                                                        accessObj.fields.find((f) =>
                                                                                            f.operations?.includes("CREATE")
                                                                                        ) !== undefined
                                                                                    ) {
                                                                                        accessObj.fields.push(nf)
                                                                                    }
                                                                                })
                                                                            })
                                                                        } else {
                                                                            context.userForm.user.userData.access.forEach((accessObj) => {
                                                                                if (
                                                                                    Array.isArray(accessObj.fields) &&
                                                                                    accessObj.fields.find((f) => f.operations?.includes("CREATE")) !==
                                                                                        undefined
                                                                                ) {
                                                                                    accessObj.fields.push({
                                                                                        fieldName: context.fieldForm.field.name,
                                                                                        operations: ["CREATE"],
                                                                                    })
                                                                                }
                                                                            })
                                                                        }
                                                                    }

                                                                    return {
                                                                        ...context.userForm,
                                                                        user: {
                                                                            ...context.userForm.user,
                                                                            userData: {
                                                                                ...context.userForm.user.userData,
                                                                                fields,
                                                                            },
                                                                        },
                                                                    }
                                                                },
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                    DELETE_FIELD: {
                                                        target: "observeFields",
                                                        actions: [
                                                            DesignerModel.assign({
                                                                // FIXME: check if field is used in any other entity as remoteConnetionField (irrelevant until allow more tahn just _id as remote connection field)
                                                                userForm: (context) => {
                                                                    const fields = context.userForm.user.userData.fields
                                                                    const accesses = context.userForm.user.userData.access

                                                                    fields.splice(
                                                                        fields.findIndex(
                                                                            (field) => field.name === context.fieldForm.originalField?.name
                                                                        ),
                                                                        1
                                                                    )

                                                                    accesses.forEach((acc) => {
                                                                        if (Array.isArray(acc.fields)) {
                                                                            acc.fields = acc.fields.filter((af) => {
                                                                                if (af.fieldName !== context.fieldForm.originalField?.name) {
                                                                                    if (
                                                                                        af.fieldName !==
                                                                                        context.fieldForm.originalField?.name + "Id"
                                                                                    ) {
                                                                                        return af
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    })

                                                                    return {
                                                                        ...context.userForm,
                                                                        user: {
                                                                            ...context.userForm.user,
                                                                            userData: {
                                                                                ...context.userForm.user.userData,
                                                                                access: accesses,
                                                                                fields,
                                                                            },
                                                                        },
                                                                    }
                                                                },
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                },
                                            },
                                        },
                                    },
                                    permissions: {
                                        initial: "hidden",
                                        states: {
                                            hidden: {
                                                on: {
                                                    OBSERVE_PERMISSIONS: {
                                                        target: "observePermissions",
                                                        actions: [
                                                            DesignerModel.assign({
                                                                accessItems: (context, event) => event.accessItems,
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                },
                                            },
                                            observePermissions: {
                                                on: {
                                                    HIDE_PERMISSIONS: { target: "hidden", actions: "trackAction" },
                                                    PERMISSION_FORM: {
                                                        target: "permissionForm",
                                                        actions: ["openPermissionsForm", "trackAction"],
                                                    },
                                                    SET_INVITABLE: {
                                                        actions: [
                                                            DesignerModel.assign({
                                                                userForm: (context, event) => {
                                                                    const invitableBy = context.userForm.user.invitableBy ?? []
                                                                    if (!invitableBy.includes(event.groupName)) {
                                                                        invitableBy.push(event.groupName)
                                                                    } else {
                                                                        invitableBy.splice(
                                                                            invitableBy.findIndex(
                                                                                (invitableByItem) => invitableByItem === event.groupName
                                                                            ),
                                                                            1
                                                                        )
                                                                    }

                                                                    return {
                                                                        ...context.userForm,
                                                                        user: {
                                                                            ...context.userForm.user,
                                                                            invitableBy,
                                                                        },
                                                                    }
                                                                },
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                    SWITCH_INVITABLE: {
                                                        actions: [
                                                            DesignerModel.assign({
                                                                userForm: (context) => ({
                                                                    ...context.userForm,
                                                                    user: {
                                                                        ...context.userForm.user,
                                                                        invitable: !context.userForm.user.invitable,
                                                                    },
                                                                }),
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                    SWITCH_SIGNUPABLE: {
                                                        actions: [
                                                            DesignerModel.assign({
                                                                userForm: (context) => {
                                                                    const currentUserData = context.userForm.user.userData
                                                                    const newFields: AccessField[] = []

                                                                    Object.keys(currentUserData.defaultFields).forEach((df) => {
                                                                        if (df !== "createdBy" && df !== "invitedBy") {
                                                                            newFields.push({ fieldName: df, operations: ["READ"] })
                                                                        }
                                                                    })

                                                                    currentUserData.fields.forEach((field) => {
                                                                        newFields.push({ fieldName: field.name, operations: ["CREATE", "READ"] })
                                                                    })

                                                                    const userSelfAccessItem: AccessItem = {
                                                                        fields: newFields,
                                                                        rule: {
                                                                            andConditions: [
                                                                                { objectFieldRoute: { fieldName: "_id" }, userAccessValue: "_id" },
                                                                            ],
                                                                            description: "",
                                                                            name: "UserSelf",
                                                                            type: "AND",
                                                                        },
                                                                        type: "USERGROUP",
                                                                        userGroupName: context.userForm.originalUser?.groupName,
                                                                    }
                                                                    const index = currentUserData.access.findIndex((ai) =>
                                                                        isEqual(ai, userSelfAccessItem)
                                                                    )
                                                                    if (context.userForm.user.signupable) {
                                                                        if (index !== -1) {
                                                                            currentUserData.access.splice(index, 1)
                                                                        }
                                                                    } else {
                                                                        currentUserData.access.push(userSelfAccessItem)
                                                                    }
                                                                    return {
                                                                        ...context.userForm,
                                                                        user: {
                                                                            ...context.userForm.user,
                                                                            signupable: !context.userForm.user.signupable,
                                                                            userData: {
                                                                                ...context.userForm.user.userData,
                                                                                access: currentUserData.access,
                                                                            },
                                                                        },
                                                                    }
                                                                },
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                    SET_EMAIL_INVITATION_URL: {
                                                        actions: [
                                                            DesignerModel.assign({
                                                                userForm: (context, event) => ({
                                                                    ...context.userForm,
                                                                    user: {
                                                                        ...context.userForm.user,
                                                                        acceptEmailInvitationDestinationUrl: event.url,
                                                                    },
                                                                }),
                                                            }),
                                                        ],
                                                    },
                                                    SET_USER_INVITATION_URL: {
                                                        actions: [
                                                            DesignerModel.assign({
                                                                userForm: (context, event) => ({
                                                                    ...context.userForm,
                                                                    user: {
                                                                        ...context.userForm.user,
                                                                        acceptUserInvitationDestinationUrl: event.url,
                                                                    },
                                                                }),
                                                            }),
                                                        ],
                                                    },
                                                },
                                            },
                                            permissionForm: {
                                                on: {
                                                    SAVE_PERMISSION: { target: "observePermissions", actions: "trackAction" },
                                                    ADD_CONDITION: {
                                                        actions: ["addCondition", "trackAction"],
                                                    },
                                                    SET_USER_GROUP_NAME: {
                                                        actions: ["setUserGroupName", "trackAction"],
                                                    },
                                                    SWITCH_RESTRICTION: {
                                                        actions: ["switchRestriction", "trackAction"],
                                                    },
                                                    SELECT_ANDCONDITION_OBJECT_FIELD: {
                                                        actions: ["selectAndConditionObjectField", "trackAction"],
                                                    },
                                                    SWITCH_ACCESS_FIELDS: {
                                                        actions: ["switchAccessFields", "trackAction"],
                                                    },
                                                    CHANGE_ACCESS_TYPE: {
                                                        actions: ["changeAccessType", "trackAction"],
                                                    },
                                                    DELETE_ACCESS_PERMISSION: {
                                                        target: "observePermissions",
                                                        actions: ["deleteAccessPermission", "trackAction"],
                                                    },
                                                    RESET_ACCES_PERMISSION: {
                                                        actions: ["resetAccesPermission", "trackAction"],
                                                    },
                                                    CANCEL_ACCESS_PERMISSION: {
                                                        target: "observePermissions",
                                                        actions: "trackAction",
                                                    },
                                                    SAVE_ACCESS_PERMISSION: {
                                                        target: "observePermissions",
                                                        actions: ["saveAccessPermission", "trackAction"],
                                                    },
                                                    CHANGE_RULE_NAME: {
                                                        actions: ["changeRuleName", "trackAction"],
                                                    },
                                                    CHANGE_RULE_DESCRIPTION: {
                                                        actions: ["changeRuleDescription"],
                                                    },
                                                    SET_USER_ACCESS_VALUE: {
                                                        actions: ["setUserAccessValue", "trackAction"],
                                                    },
                                                    DELETE_CONDITION: {
                                                        actions: ["deleteCondition", "trackAction"],
                                                    },
                                                    // Unique only for user permissions
                                                    CHANGE_FIELD_ACCESS: {
                                                        actions: ["changeAccessField", "trackAction"],
                                                    },

                                                    SET_CONST_VALUE: {
                                                        actions: ["setConstValue", "trackAction"],
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                            savingConfig: {
                                type: "atomic",
                                invoke: {
                                    id: "designerMachine-saveConfig",
                                    src: "saveConfig",
                                },
                                on: {
                                    ERROR: {
                                        target: "userForm",
                                        actions: "trackAction",
                                    },
                                    SAVED: {
                                        target: "observeUserGroupsList",
                                        actions: [
                                            DesignerModel.assign((ctx, event) => {
                                                return {
                                                    projectConfig: {
                                                        ...ctx.projectConfig,
                                                        _id: event.configId,
                                                        updatedAt: event.configSaveResult.projectConfigDiff.latestUpdatedAtISOString!,
                                                        apiVersion:
                                                            event.configSaveResult.projectConfigDiff.latestVersion! < ctx.projectConfig.apiVersion
                                                                ? ctx.projectConfig.apiVersion
                                                                : event.configSaveResult.projectConfigDiff.latestVersion!,
                                                    },
                                                    project: {
                                                        ...ctx.project,
                                                        ...event.configSaveResult.projectDiff,
                                                    },
                                                    userForm: {
                                                        user: JSON.parse(JSON.stringify(DesignerModel.initialContext.userForm.user)),
                                                        originalUser: undefined,
                                                    },
                                                }
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                            deployingVersion: {
                                type: "atomic",
                                invoke: {
                                    id: "designerMachine-deployConfig",
                                    src: "deployConfig",
                                },
                                on: {
                                    ERROR: {
                                        target: "observeUserGroupsList",
                                        actions: "trackAction",
                                    },
                                    DEPLOYED: {
                                        target: "observeUserGroupsList", // FIXME: render pop-up with deployment report here and in 3 places below [Tasks]
                                        actions: [
                                            DesignerModel.assign((ctx, event) => {
                                                return {
                                                    project: {
                                                        ...ctx.project,
                                                        ...event.configDeployResult.projectDiff,
                                                    },
                                                    configReport: event.configDeployResult.configReport,
                                                    projectConfig: {
                                                        ...ctx.projectConfig,
                                                        apiVersion: event.configDeployResult.projectConfigDiff.apiVersion!,
                                                        updatedAt: event.configDeployResult.projectConfigDiff.updatedAtISOString!,
                                                    },
                                                }
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                            deploymentReport: {},
                        },
                    },

                    // Data entities related logic
                    entities: {
                        on: {
                            USERS: { target: "users", actions: "trackAction" },
                            SUBOBJECTS: { target: "subobjects", actions: "trackAction" },
                            ENUMS: { target: "enums", actions: "trackAction" },
                            DEPLOY_VERSION: { target: ".deployingVersion", actions: "trackAction" },
                        },
                        initial: "observeEntitiesList",
                        states: {
                            observeEntitiesList: {
                                on: {
                                    ENTITY_FORM: {
                                        target: "entityForm",
                                        actions: [
                                            DesignerModel.assign({
                                                entityForm: (context, event) =>
                                                    event.entity
                                                        ? {
                                                              entity: JSON.parse(JSON.stringify(event.entity)),
                                                              originalEntity: JSON.parse(JSON.stringify(event.entity)),
                                                          }
                                                        : context.projectConfig.users.findIndex((u) => u.groupName == "Admin") != -1
                                                          ? {
                                                                entity: {
                                                                    ...JSON.parse(JSON.stringify(DesignerModel.initialContext.entityForm.entity)),
                                                                    access: [
                                                                        {
                                                                            type: "USERGROUP",
                                                                            rule: {
                                                                                type: "ANY",
                                                                                name: "",
                                                                                description: "",
                                                                            },
                                                                            fields: "ALL",
                                                                            userGroupName: "Admin",
                                                                        },
                                                                    ],
                                                                },
                                                                originalEntity: undefined,
                                                            }
                                                          : {
                                                                entity: JSON.parse(JSON.stringify(DesignerModel.initialContext.entityForm.entity)),
                                                                originalEntity: undefined,
                                                            },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                            entityForm: {
                                type: "parallel",
                                on: {
                                    CHANGE_ENTITY_NAME: {
                                        actions: [
                                            DesignerModel.assign({
                                                entityForm: (context, event) => {
                                                    const entityNameArr = event.entityName.split(" ")
                                                    for (const en in entityNameArr) {
                                                        // remove spaces, special characters, numbers and keep only letters
                                                        entityNameArr[en] = entityNameArr[en].replace(/[^a-zA-Z]/g, "")
                                                        // set each word first letter to uppercase
                                                        entityNameArr[en] = entityNameArr[en].charAt(0).toUpperCase() + entityNameArr[en].slice(1)
                                                    }
                                                    const cleanEntityName = entityNameArr.join("")

                                                    // // set first letter to lowercase
                                                    // cleanEntityName = cleanEntityName.charAt(0).toLowerCase() + cleanEntityName.slice(1)

                                                    return {
                                                        ...context.entityForm,
                                                        entity: { ...context.entityForm.entity, entityName: cleanEntityName },
                                                    }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    CHANGE_ENTITY_DESCRIPTION: {
                                        actions: [
                                            DesignerModel.assign({
                                                entityForm: (context, event) => ({
                                                    ...context.entityForm,
                                                    entity: { ...context.entityForm.entity, description: event.description },
                                                }),
                                            }),
                                        ],
                                    },
                                    SWITCH_TRACK_ENTITY_CHANGES: {
                                        actions: [
                                            DesignerModel.assign({
                                                entityForm: (context) => ({
                                                    ...context.entityForm,
                                                    entity: {
                                                        ...context.entityForm.entity,
                                                        trackChanges: !context.entityForm.entity.trackChanges,
                                                    },
                                                }),
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    SAVE_ENTITY: {
                                        target: "savingConfig",
                                        actions: [
                                            DesignerModel.assign({
                                                projectConfig: (context) => {
                                                    const entities = context.projectConfig.entities
                                                    const users = context.projectConfig.users
                                                    const subObjects = context.projectConfig.subObjects
                                                    const newEntity = context.entityForm.entity
                                                    const originalEntity = context.entityForm.originalEntity

                                                    if (originalEntity) {
                                                        newEntity.fields.forEach((ne) => {
                                                            if (ne?.connectedEntityName === originalEntity?.entityName) {
                                                                ne.connectedEntityName = newEntity.entityName
                                                            }
                                                        })

                                                        users.forEach((user) => {
                                                            for (let i = user.userData.fields.length; i >= 0; i--) {
                                                                if (user.userData.fields[i]?.connectedEntityName === originalEntity?.entityName) {
                                                                    if (user.userData.fields[i]?.connectedEntityRemoteFieldName) {
                                                                        user.userData.fields.splice(i, 1)
                                                                    } else {
                                                                        user.userData.fields[i].connectedEntityName = newEntity.entityName
                                                                    }
                                                                }
                                                            }
                                                        })

                                                        subObjects &&
                                                            Object.values(subObjects).forEach((sb) => {
                                                                sb.fields.forEach((sbf) => {
                                                                    if (sbf?.connectedEntityName === originalEntity?.entityName) {
                                                                        sbf.connectedEntityName = newEntity.entityName
                                                                    }
                                                                })
                                                            })
                                                    }

                                                    for (const field of newEntity.fields) {
                                                        if (field.connectionUnderlyingField) {
                                                            let remoteConnectionExists = false
                                                            const remoteEntity = entities.find((e) => e.entityName == field.connectedEntityName)
                                                            let newName = getPlural(newEntity.entityName)
                                                            newName =
                                                                newName.slice(0, 1).toLowerCase() +
                                                                newName.slice(1) +
                                                                "By" +
                                                                field.name.substring(0, 1).toUpperCase() +
                                                                field.name.substring(1)
                                                            const newField = {
                                                                name: newName,
                                                                type: "CONNECTION_CONTAINS",
                                                                connectedEntityName: newEntity.entityName,
                                                                connectedEntityRemoteFieldName: field.connectionUnderlyingField.name,
                                                            } as EntityField

                                                            if (remoteEntity) {
                                                                for (const rField of remoteEntity.fields) {
                                                                    if (
                                                                        rField.connectedEntityName == newEntity.entityName &&
                                                                        rField.name == newName
                                                                    ) {
                                                                        remoteConnectionExists = true
                                                                        break
                                                                    }
                                                                }
                                                                if (!remoteConnectionExists) {
                                                                    remoteEntity.fields.push(newField)
                                                                }
                                                            } else {
                                                                const remoteUser = users.find((u) => u.groupName == field.connectedEntityName)
                                                                if (remoteUser) {
                                                                    for (const rField of remoteUser.userData.fields) {
                                                                        if (
                                                                            rField.connectedEntityName == newEntity.entityName &&
                                                                            rField.name == newName
                                                                        ) {
                                                                            remoteConnectionExists = true
                                                                            break
                                                                        }
                                                                    }
                                                                    if (!remoteConnectionExists) {
                                                                        remoteUser.userData.fields.push(newField)
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }

                                                    if (!context.entityForm.originalEntity) {
                                                        entities.push(newEntity)
                                                    } else {
                                                        entities.splice(
                                                            entities.findIndex(
                                                                (entity) => entity.entityName === context.entityForm.originalEntity?.entityName
                                                            ),
                                                            1,
                                                            newEntity
                                                        )
                                                    }

                                                    return {
                                                        ...context.projectConfig,
                                                        entities,
                                                        users,
                                                    }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    RESET_ENTITY: {
                                        actions: [
                                            DesignerModel.assign({
                                                entityForm: (context) => {
                                                    if (!context.entityForm.originalEntity)
                                                        return {
                                                            ...JSON.parse(JSON.stringify(DesignerModel.initialContext.entityForm)),
                                                            originalEntity: undefined,
                                                        }
                                                    else
                                                        return {
                                                            ...context.entityForm,
                                                            entity: context.entityForm.originalEntity,
                                                        }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    CANCEL_ENTITY: {
                                        target: "observeEntitiesList",
                                        actions: [
                                            DesignerModel.assign({
                                                entityForm: {
                                                    entity: JSON.parse(JSON.stringify(DesignerModel.initialContext.entityForm.entity)),
                                                    originalEntity: undefined,
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    DELETE_ENTITY: {
                                        target: "savingConfig",
                                        actions: [
                                            DesignerModel.assign({
                                                projectConfig: (context) => {
                                                    if (!context.entityForm.originalEntity) return { ...context.projectConfig }

                                                    const entityName = context.entityForm.originalEntity!.entityName
                                                    const entities = context.projectConfig.entities
                                                    const users = context.projectConfig.users

                                                    entities.splice(
                                                        entities.findIndex((entity) => entity.entityName === entityName),
                                                        1
                                                    )

                                                    for (const u of users) {
                                                        for (let ufi = u.userData.fields.length - 1; ufi >= 0; ufi--) {
                                                            const uf = u.userData.fields[ufi]
                                                            if (uf.connectedEntityName == entityName) {
                                                                for (const ua of u.userData.access) {
                                                                    if (ua.fields !== "ALL") {
                                                                        for (let uaf = 0; uaf < ua.fields.length; uaf++) {
                                                                            if (ua.fields[uaf].fieldName == uf.name) {
                                                                                ua.fields.splice(uaf, 1)
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                u.userData.fields.splice(ufi, 1)
                                                            }
                                                        }
                                                    }

                                                    for (const e of entities) {
                                                        for (let efi = 0; efi < e.fields.length; efi++) {
                                                            const ef = e.fields[efi]
                                                            if (ef.connectedEntityName == entityName) {
                                                                for (const ea of e.access) {
                                                                    if (ea.fields !== "ALL") {
                                                                        for (let eaf = ea.fields.length - 1; eaf >= 0; eaf--) {
                                                                            if (ea.fields[eaf].fieldName == ef.name) {
                                                                                ea.fields.splice(eaf, 1)
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                e.fields.splice(efi, 1)
                                                            }
                                                        }
                                                    }
                                                    const subObjects = context.projectConfig.subObjects
                                                    if (subObjects) {
                                                        for (const sk of Object.keys(subObjects)) {
                                                            const s = subObjects[sk]
                                                            for (let sfi = s.fields.length - 1; sfi >= 0; sfi--) {
                                                                const sf = s.fields[sfi]
                                                                if (sf.connectedEntityName == entityName) {
                                                                    s.fields.splice(sfi, 1)
                                                                }
                                                            }
                                                        }
                                                    }

                                                    return {
                                                        ...context.projectConfig,
                                                        entities,
                                                    }
                                                },
                                                entityForm: {
                                                    entity: JSON.parse(JSON.stringify(DesignerModel.initialContext.entityForm.entity)),
                                                    originalEntity: undefined,
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                                states: {
                                    fields: {
                                        initial: "observeFields",
                                        states: {
                                            observeFields: {
                                                on: {
                                                    FIELD_FORM: {
                                                        target: "fieldForm",
                                                        actions: [
                                                            DesignerModel.assign({
                                                                fieldForm: (_, event) =>
                                                                    event.field
                                                                        ? {
                                                                              field: JSON.parse(JSON.stringify(event.field)),
                                                                              originalField: JSON.parse(JSON.stringify(event.field)),
                                                                          }
                                                                        : {
                                                                              field: JSON.parse(
                                                                                  JSON.stringify(DesignerModel.initialContext.fieldForm.field)
                                                                              ),
                                                                              originalField: undefined,
                                                                          },
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                },
                                            },
                                            fieldForm: {
                                                on: {
                                                    CHANGE_FIELD_NAME: {
                                                        actions: ["changeFieldName", "trackAction"],
                                                    },
                                                    RESET_FIELD: {
                                                        actions: ["resetField", "trackAction"],
                                                    },
                                                    CANCEL_FIELD: {
                                                        target: "observeFields",
                                                        actions: "trackAction",
                                                    },
                                                    CHANGE_FIELD_DESCRIPTION: {
                                                        actions: ["changeFieldDescription"],
                                                    },
                                                    CHANGE_FIELD_TYPE: {
                                                        actions: ["changeFieldType", "trackAction"],
                                                    },
                                                    SWITCH_MANDATORY: {
                                                        actions: ["switchMandatory", "trackAction"],
                                                    },
                                                    SWITCH_ISARRAY: {
                                                        actions: ["switchIsArray", "trackAction"],
                                                    },
                                                    SWITCH_MUTABLE: {
                                                        actions: ["switchMutable", "trackAction"],
                                                    },
                                                    CHANGE_CONNECTION_UNDERLYING_FIELD_NAME: {
                                                        actions: ["changeConnectionUnderlyingFieldName", "trackAction"],
                                                    },
                                                    SET_REMOTE_FIELD_NAME: {
                                                        actions: ["setRemoteFieldName", "trackAction"],
                                                    },
                                                    SWITCH_UNDERLYING_MANDATORY: {
                                                        actions: ["switchUnderlyingMandatory", "trackAction"],
                                                    },
                                                    SWITCH_UNDERLYING_ISARRAY: {
                                                        actions: ["switchUnderlyingIsArray", "trackAction"],
                                                    },
                                                    SWITCH_UNDERLYING_MULTABLE: {
                                                        actions: ["switchUnderlyingMutable", "trackAction"],
                                                    },
                                                    // Unique only for entity fields
                                                    SAVE_FIELD: {
                                                        target: "observeFields",
                                                        actions: [
                                                            DesignerModel.assign({
                                                                entityForm: (context) => {
                                                                    const fields = context.entityForm.entity.fields
                                                                    if (!context.fieldForm.originalField) {
                                                                        fields.push(context.fieldForm.field)
                                                                    } else {
                                                                        fields.splice(
                                                                            fields.findIndex(
                                                                                (field) => field.name === context.fieldForm.originalField?.name
                                                                            ),
                                                                            1,
                                                                            context.fieldForm.field
                                                                        )
                                                                    }

                                                                    if (context.fieldForm.field.mandatory) {
                                                                        if (context.fieldForm.field.subObjectName) {
                                                                            const subFieldNames = getSubMandatoryFieldNames(
                                                                                context.projectConfig,
                                                                                fields,
                                                                                context.fieldForm.field.name
                                                                            )

                                                                            const newFields = subFieldNames.map((fn) => ({
                                                                                fieldName: context.fieldForm.field.name,
                                                                                operations: ["CREATE" as Operation],
                                                                                subfield: { fieldName: fn },
                                                                            }))

                                                                            context.entityForm.entity.access.forEach((accessObj) => {
                                                                                newFields.forEach((nf) => {
                                                                                    if (
                                                                                        Array.isArray(accessObj.fields) &&
                                                                                        accessObj.fields.find((f) =>
                                                                                            f.operations?.includes("CREATE")
                                                                                        ) !== undefined
                                                                                    ) {
                                                                                        accessObj.fields.push(nf)
                                                                                    }
                                                                                })
                                                                            })
                                                                        } else {
                                                                            context.entityForm.entity.access.forEach((accessObj) => {
                                                                                if (
                                                                                    Array.isArray(accessObj.fields) &&
                                                                                    accessObj.fields.find((f) => f.operations?.includes("CREATE")) !==
                                                                                        undefined
                                                                                ) {
                                                                                    accessObj.fields.push({
                                                                                        fieldName: context.fieldForm.field.name,
                                                                                        operations: ["CREATE"],
                                                                                    })
                                                                                }
                                                                            })
                                                                        }
                                                                    }

                                                                    return {
                                                                        ...context.entityForm,
                                                                        entity: {
                                                                            ...context.entityForm.entity,
                                                                            fields,
                                                                        },
                                                                    }
                                                                },
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                    DELETE_FIELD: {
                                                        target: "observeFields",
                                                        actions: [
                                                            DesignerModel.assign({
                                                                // FIXME: check if field is used in any other entity as remoteConnetionField (irrelevant until allow more tahn just _id as remote connection field)
                                                                entityForm: (context) => {
                                                                    const fields = context.entityForm.entity.fields
                                                                    const accesses = context.entityForm.entity.access
                                                                    fields.splice(
                                                                        fields.findIndex(
                                                                            (field) => field.name === context.fieldForm.originalField?.name
                                                                        ),
                                                                        1
                                                                    )

                                                                    accesses.forEach((acc) => {
                                                                        if (Array.isArray(acc.fields)) {
                                                                            acc.fields = acc.fields.filter((af) => {
                                                                                if (af.fieldName !== context.fieldForm.originalField?.name) {
                                                                                    if (
                                                                                        af.fieldName !==
                                                                                        context.fieldForm.originalField?.name + "Id"
                                                                                    ) {
                                                                                        return af
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    })

                                                                    return {
                                                                        ...context.entityForm,
                                                                        entity: {
                                                                            ...context.entityForm.entity,
                                                                            access: accesses,
                                                                            fields,
                                                                        },
                                                                    }
                                                                },
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                },
                                            },
                                        },
                                    },
                                    permissions: {
                                        initial: "hidden",
                                        states: {
                                            hidden: {
                                                on: {
                                                    OBSERVE_PERMISSIONS: {
                                                        target: "observePermissions",
                                                        actions: [
                                                            DesignerModel.assign({
                                                                accessItems: (_, event) => event.accessItems,
                                                            }),
                                                            "trackAction",
                                                        ],
                                                    },
                                                },
                                            },
                                            observePermissions: {
                                                on: {
                                                    HIDE_PERMISSIONS: {
                                                        target: "hidden",
                                                        actions: "trackAction",
                                                    },
                                                    PERMISSION_FORM: {
                                                        target: "permissionForm",
                                                        actions: ["openPermissionsForm", "trackAction"],
                                                    },
                                                },
                                            },
                                            permissionForm: {
                                                on: {
                                                    SAVE_PERMISSION: { target: "observePermissions" },
                                                    ADD_CONDITION: {
                                                        actions: ["addCondition", "trackAction"],
                                                    },
                                                    SET_USER_GROUP_NAME: {
                                                        actions: ["setUserGroupName", "trackAction"],
                                                    },
                                                    SWITCH_RESTRICTION: {
                                                        actions: ["switchRestriction", "trackAction"],
                                                    },
                                                    SELECT_ANDCONDITION_OBJECT_FIELD: {
                                                        actions: ["selectAndConditionObjectField", "trackAction"],
                                                    },
                                                    SWITCH_ACCESS_FIELDS: {
                                                        actions: ["switchAccessFields", "trackAction"],
                                                    },
                                                    CHANGE_ACCESS_TYPE: {
                                                        actions: ["changeAccessType", "trackAction"],
                                                    },
                                                    DELETE_ACCESS_PERMISSION: {
                                                        target: "observePermissions",
                                                        actions: ["deleteAccessPermission", "trackAction"],
                                                    },
                                                    RESET_ACCES_PERMISSION: {
                                                        actions: ["resetAccesPermission", "trackAction"],
                                                    },
                                                    CANCEL_ACCESS_PERMISSION: {
                                                        target: "observePermissions",
                                                        actions: "trackAction",
                                                    },
                                                    SAVE_ACCESS_PERMISSION: {
                                                        target: "observePermissions",
                                                        actions: ["saveAccessPermission", "trackAction"],
                                                    },
                                                    CHANGE_RULE_NAME: {
                                                        actions: ["changeRuleName", "trackAction"],
                                                    },
                                                    CHANGE_RULE_DESCRIPTION: {
                                                        actions: ["changeRuleDescription"],
                                                    },
                                                    SET_USER_ACCESS_VALUE: {
                                                        actions: ["setUserAccessValue", "trackAction"],
                                                    },
                                                    DELETE_CONDITION: {
                                                        actions: ["deleteCondition", "trackAction"],
                                                    },
                                                    // Unique only for entity permissions
                                                    CHANGE_FIELD_ACCESS: {
                                                        actions: ["changeAccessField", "trackAction"],
                                                    },
                                                    SET_CONST_VALUE: {
                                                        actions: ["setConstValue", "trackAction"],
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                            savingConfig: {
                                type: "atomic",
                                invoke: {
                                    id: "designerMachine-saveConfig",
                                    src: "saveConfig",
                                },
                                on: {
                                    ERROR: {
                                        target: "entityForm",
                                    },
                                    SAVED: {
                                        target: "observeEntitiesList",
                                        actions: [
                                            DesignerModel.assign({
                                                projectConfig: (ctx, event) => {
                                                    return {
                                                        ...ctx.projectConfig,
                                                        _id: event.configId,
                                                        updatedAt: event.configSaveResult.projectConfigDiff.latestUpdatedAtISOString!,
                                                        apiVersion:
                                                            event.configSaveResult.projectConfigDiff.latestVersion! < ctx.projectConfig.apiVersion
                                                                ? ctx.projectConfig.apiVersion
                                                                : event.configSaveResult.projectConfigDiff.latestVersion!,
                                                    }
                                                },
                                                entityForm: {
                                                    entity: JSON.parse(JSON.stringify(DesignerModel.initialContext.entityForm.entity)),
                                                    originalEntity: undefined,
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                            deployingVersion: {
                                type: "atomic",
                                invoke: {
                                    id: "designerMachine-deployConfig",
                                    src: "deployConfig",
                                },
                                on: {
                                    ERROR: {
                                        target: "observeEntitiesList",
                                    },
                                    DEPLOYED: {
                                        target: "observeEntitiesList",
                                        actions: [
                                            DesignerModel.assign((ctx, event) => {
                                                return {
                                                    project: {
                                                        ...ctx.project,
                                                        ...event.configDeployResult.projectDiff,
                                                    },
                                                    configReport: event.configDeployResult.configReport,
                                                    projectConfig: {
                                                        ...ctx.projectConfig,
                                                        apiVersion: event.configDeployResult.projectConfigDiff.apiVersion!,
                                                        updatedAt: event.configDeployResult.projectConfigDiff.updatedAtISOString!,
                                                    },
                                                }
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                        },
                    },

                    // Sub-objects related logic
                    subobjects: {
                        on: {
                            USERS: { target: "users", actions: "trackAction" },
                            ENTITIES: { target: "entities", actions: "trackAction" },
                            ENUMS: { target: "enums", actions: "trackAction" },
                            DELETE_SUBOBJECT: {
                                actions: [
                                    DesignerModel.assign({
                                        projectConfig: (context, event) => {
                                            const subObjects = context.projectConfig.subObjects
                                            delete subObjects![event.key]

                                            return {
                                                ...context.projectConfig,
                                                subObjects,
                                            }
                                        },
                                    }),
                                    "trackAction",
                                ],
                            },
                            DEPLOY_VERSION: { target: ".deployingVersion", actions: "trackAction" },
                        },
                        initial: "observeSubObjectsList",
                        states: {
                            observeSubObjectsList: {
                                id: "observeSubObjectsList",
                                on: {
                                    SUBOBJECT_FORM: {
                                        target: "subObjectForm",
                                        actions: ["setSubObjectForm", "trackAction"],
                                    },
                                },
                            },
                            subObjectForm: {
                                initial: "observeFields",
                                on: {
                                    CHANGE_SUBOBJECT_NAME: {
                                        actions: [
                                            DesignerModel.assign({
                                                subObjectForm: (context, event) => {
                                                    const subObjectNameArr = event.name.split(" ")
                                                    for (const en in subObjectNameArr) {
                                                        // remove spaces, special characters, numbers and keep only letters
                                                        subObjectNameArr[en] = subObjectNameArr[en].replace(/[^a-zA-Z]/g, "")
                                                        // set each word first letter to uppercase
                                                        subObjectNameArr[en] =
                                                            subObjectNameArr[en].charAt(0).toUpperCase() + subObjectNameArr[en].slice(1)
                                                    }
                                                    const cleanSubObjectName = subObjectNameArr.join("")

                                                    return {
                                                        ...context.subObjectForm,
                                                        subObject: { ...context.subObjectForm.subObject, name: cleanSubObjectName },
                                                    }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    SAVE_SUBOBJECT: {
                                        target: ".savingConfig",
                                        actions: [
                                            DesignerModel.assign({
                                                projectConfig: (context) => {
                                                    let subObjects = context.projectConfig.subObjects
                                                    const originalSubObject = context.subObjectForm.originalSubObject
                                                    const newSubObject = context.subObjectForm.subObject

                                                    if (originalSubObject) {
                                                        if (subObjects?.[originalSubObject.name]) {
                                                            delete subObjects[originalSubObject.name]
                                                        }
                                                    }

                                                    if (subObjects) {
                                                        subObjects[newSubObject.name] = {
                                                            fields: newSubObject.fields,
                                                        }
                                                    } else {
                                                        subObjects = {
                                                            [newSubObject.name]: { fields: newSubObject.fields },
                                                        }
                                                    }

                                                    return {
                                                        ...context.projectConfig,
                                                        subObjects,
                                                    }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    COLLAPSE_FORM: {
                                        target: "observeSubObjectsList",
                                        actions: [
                                            DesignerModel.assign({
                                                subObjectForm: {
                                                    subObject: JSON.parse(JSON.stringify(DesignerModel.initialContext.subObjectForm.subObject)),
                                                    originalSubObject: undefined,
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                                states: {
                                    observeFields: {
                                        on: {
                                            SUBOBJECT_FORM: {
                                                actions: ["setSubObjectForm", "trackAction"],
                                            },
                                            FIELD_FORM: {
                                                target: "fieldForm",
                                                actions: [
                                                    DesignerModel.assign({
                                                        fieldForm: (_, event) => {
                                                            return event.field
                                                                ? {
                                                                      field: JSON.parse(JSON.stringify(event.field)),
                                                                      originalField: JSON.parse(JSON.stringify(event.field)),
                                                                      formType: "SubObjectForm",
                                                                      parentFieldUsedinEntityFieldNames: event.connectionFieldNames,
                                                                  }
                                                                : {
                                                                      field: JSON.parse(JSON.stringify(DesignerModel.initialContext.fieldForm.field)),
                                                                      originalField: undefined,
                                                                      formType: "SubObjectForm",
                                                                      parentFieldUsedinEntityFieldNames: event.connectionFieldNames,
                                                                  }
                                                        },
                                                    }),
                                                    "trackAction",
                                                ],
                                            },
                                        },
                                    },
                                    fieldForm: {
                                        on: {
                                            CHANGE_FIELD_NAME: {
                                                actions: ["changeFieldName", "trackAction"],
                                            },
                                            RESET_FIELD: {
                                                actions: ["resetField", "trackAction"],
                                            },
                                            CANCEL_FIELD: {
                                                target: "observeFields",
                                                actions: "trackAction",
                                            },
                                            CHANGE_FIELD_DESCRIPTION: {
                                                actions: ["changeFieldDescription"],
                                            },
                                            CHANGE_FIELD_TYPE: {
                                                actions: ["changeFieldType", "trackAction"],
                                            },
                                            SWITCH_MANDATORY: {
                                                actions: ["switchMandatory", "trackAction"],
                                            },
                                            SWITCH_ISARRAY: {
                                                actions: ["switchIsArray", "trackAction"],
                                            },
                                            SWITCH_MUTABLE: {
                                                actions: ["switchMutable", "trackAction"],
                                            },
                                            CHANGE_CONNECTION_UNDERLYING_FIELD_NAME: {
                                                actions: ["changeConnectionUnderlyingFieldName", "trackAction"],
                                            },
                                            SET_REMOTE_FIELD_NAME: {
                                                actions: ["setRemoteFieldName", "trackAction"],
                                            },
                                            SWITCH_UNDERLYING_MANDATORY: {
                                                actions: ["switchUnderlyingMandatory", "trackAction"],
                                            },
                                            SWITCH_UNDERLYING_ISARRAY: {
                                                actions: ["switchUnderlyingIsArray", "trackAction"],
                                            },
                                            SWITCH_UNDERLYING_MULTABLE: {
                                                actions: ["switchUnderlyingMutable", "trackAction"],
                                            },
                                            // Unique only for subObject fields
                                            SUBOBJECT_FORM: {
                                                target: "observeFields",
                                                actions: ["setSubObjectForm", "trackAction"],
                                            },
                                            SAVE_FIELD: {
                                                target: "observeFields",
                                                actions: [
                                                    DesignerModel.assign({
                                                        subObjectForm: (context) => {
                                                            const fields = context.subObjectForm.subObject.fields
                                                            if (!context.fieldForm.originalField) {
                                                                fields.push(context.fieldForm.field)
                                                            } else {
                                                                fields.splice(
                                                                    fields.findIndex((field) => field.name === context.fieldForm.originalField?.name),
                                                                    1,
                                                                    context.fieldForm.field
                                                                )
                                                            }

                                                            return {
                                                                ...context.subObjectForm,
                                                                subObject: {
                                                                    ...context.subObjectForm.subObject,
                                                                    fields,
                                                                },
                                                            }
                                                        },
                                                    }),
                                                    "trackAction",
                                                ],
                                            },
                                            DELETE_FIELD: {
                                                target: "observeFields",
                                                actions: [
                                                    DesignerModel.assign({
                                                        // FIXME: check if field is used in any other entity as remoteConnetionField (irrelevant until allow more tahn just _id as remote connection field)
                                                        subObjectForm: (context) => {
                                                            const fields = context.subObjectForm.subObject.fields
                                                            fields.splice(
                                                                fields.findIndex((field) => field.name === context.fieldForm.originalField?.name),
                                                                1
                                                            )

                                                            return {
                                                                ...context.subObjectForm,
                                                                subObject: {
                                                                    ...context.subObjectForm.subObject,
                                                                    fields,
                                                                },
                                                            }
                                                        },
                                                    }),
                                                    "trackAction",
                                                ],
                                            },
                                        },
                                    },
                                    savingConfig: {
                                        type: "atomic",
                                        invoke: {
                                            id: "designerMachine-saveConfig",
                                            src: "saveConfig",
                                        },
                                        on: {
                                            ERROR: {
                                                target: "observeFields",
                                            },
                                            SAVED: {
                                                target: "#observeSubObjectsList",
                                                actions: [
                                                    DesignerModel.assign({
                                                        projectConfig: (ctx, event) => {
                                                            return {
                                                                ...ctx.projectConfig,
                                                                _id: event.configId,
                                                                updatedAt: event.configSaveResult.projectConfigDiff.latestUpdatedAtISOString!,
                                                                apiVersion:
                                                                    event.configSaveResult.projectConfigDiff.latestVersion! <
                                                                    ctx.projectConfig.apiVersion
                                                                        ? ctx.projectConfig.apiVersion
                                                                        : event.configSaveResult.projectConfigDiff.latestVersion!,
                                                            }
                                                        },
                                                    }),
                                                    "trackAction",
                                                ],
                                            },
                                        },
                                    },
                                },
                            },
                            deployingVersion: {
                                type: "atomic",
                                invoke: {
                                    id: "designerMachine-deployConfig",
                                    src: "deployConfig",
                                },
                                on: {
                                    ERROR: {
                                        target: "observeSubObjectsList",
                                    },
                                    DEPLOYED: {
                                        target: "observeSubObjectsList",
                                        actions: [
                                            DesignerModel.assign((ctx, event) => {
                                                return {
                                                    project: {
                                                        ...ctx.project,
                                                        ...event.configDeployResult.projectDiff,
                                                    },
                                                    configReport: event.configDeployResult.configReport,
                                                    projectConfig: {
                                                        ...ctx.projectConfig,
                                                        apiVersion: event.configDeployResult.projectConfigDiff.apiVersion!,
                                                        updatedAt: event.configDeployResult.projectConfigDiff.updatedAtISOString!,
                                                    },
                                                }
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                        },
                    },

                    // Enums related logic
                    enums: {
                        on: {
                            USERS: { target: "users", actions: "trackAction" },
                            ENTITIES: { target: "entities", actions: "trackAction" },
                            SUBOBJECTS: { target: "subobjects", actions: "trackAction" },
                            ENUM_FORM: {
                                target: ".enumForm",
                                actions: [
                                    DesignerModel.assign({
                                        enumForm: (_, event) =>
                                            event.enumForm
                                                ? {
                                                      name: JSON.parse(JSON.stringify(event.enumForm.name)),
                                                      originalName: JSON.parse(JSON.stringify(event.enumForm.name)),
                                                      values: JSON.parse(JSON.stringify(event.enumForm.values)),
                                                  }
                                                : JSON.parse(JSON.stringify(DesignerModel.initialContext.enumForm)),
                                    }),
                                    "trackAction",
                                ],
                            },
                            DELETE_ENUM: {
                                target: ".savingConfig",
                                actions: [
                                    DesignerModel.assign({
                                        projectConfig: (context, event) => {
                                            const enums = context.projectConfig.enums!
                                            delete enums[event.enumKey]

                                            return {
                                                ...context.projectConfig,
                                                enums,
                                            }
                                        },
                                        enumForm: JSON.parse(JSON.stringify(DesignerModel.initialContext.enumForm)),
                                    }),
                                    "trackAction",
                                ],
                            },
                            DEPLOY_VERSION: { target: ".deployingVersion", actions: "trackAction" },
                        },
                        initial: "observeEnumsList",
                        states: {
                            observeEnumsList: {},
                            enumForm: {
                                on: {
                                    SAVE_ENUM: {
                                        target: "savingConfig",
                                        actions: [
                                            DesignerModel.assign({
                                                projectConfig: (context) => {
                                                    const enums = context.projectConfig.enums ?? {}
                                                    enums[context.enumForm.name] = JSON.parse(JSON.stringify(context.enumForm.values))

                                                    return {
                                                        ...context.projectConfig,
                                                        enums,
                                                    }
                                                },
                                                enumForm: JSON.parse(JSON.stringify(DesignerModel.initialContext.enumForm)),
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    CANCEL_ENUM: {
                                        target: "observeEnumsList",
                                        actions: [
                                            DesignerModel.assign({
                                                enumForm: JSON.parse(JSON.stringify(DesignerModel.initialContext.enumForm)),
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    CHANGE_ENUM_NAME: {
                                        actions: [
                                            DesignerModel.assign({
                                                enumForm: (context, event) => {
                                                    const enumNameArr = event.name.split(" ")
                                                    for (const en in enumNameArr) {
                                                        // remove spaces, special characters, numbers and keep only letters
                                                        enumNameArr[en] = enumNameArr[en].replace(/[^a-zA-Z]/g, "")
                                                        // set each word first letter to uppercase
                                                        enumNameArr[en] = enumNameArr[en].charAt(0).toUpperCase() + enumNameArr[en].slice(1)
                                                    }
                                                    const cleanEnumName = enumNameArr.join("")

                                                    return {
                                                        ...context.enumForm,
                                                        name: cleanEnumName,
                                                    }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                    CHANGE_ENUM_VALUES: {
                                        actions: [
                                            DesignerModel.assign({
                                                enumForm: (context, event) => ({
                                                    ...context.enumForm,
                                                    values: event.values,
                                                }),
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                            savingConfig: {
                                type: "atomic",
                                invoke: {
                                    id: "designerMachine-saveConfig",
                                    src: "saveConfig",
                                },
                                on: {
                                    ERROR: {
                                        target: "enumForm",
                                    },
                                    SAVED: {
                                        target: "observeEnumsList",
                                        actions: [
                                            DesignerModel.assign({
                                                projectConfig: (ctx, event) => {
                                                    return {
                                                        ...ctx.projectConfig,
                                                        _id: event.configId,
                                                        updatedAt: event.configSaveResult.projectConfigDiff.latestUpdatedAtISOString!,
                                                        apiVersion:
                                                            event.configSaveResult.projectConfigDiff.latestVersion! < ctx.projectConfig.apiVersion
                                                                ? ctx.projectConfig.apiVersion
                                                                : event.configSaveResult.projectConfigDiff.latestVersion!,
                                                    }
                                                },
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                            deployingVersion: {
                                type: "atomic",
                                invoke: {
                                    id: "designerMachine-deployConfig",
                                    src: "deployConfig",
                                },
                                on: {
                                    ERROR: {
                                        target: "observeEnumsList",
                                    },
                                    DEPLOYED: {
                                        target: "observeEnumsList",
                                        actions: [
                                            DesignerModel.assign((ctx, event) => {
                                                return {
                                                    project: {
                                                        ...ctx.project,
                                                        ...event.configDeployResult.projectDiff,
                                                    },
                                                    configReport: event.configDeployResult.configReport,
                                                    projectConfig: {
                                                        ...ctx.projectConfig,
                                                        apiVersion: event.configDeployResult.projectConfigDiff.apiVersion!,
                                                        updatedAt: event.configDeployResult.projectConfigDiff.updatedAtISOString!,
                                                    },
                                                }
                                            }),
                                            "trackAction",
                                        ],
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
    {
        actions: {
            trackAction: (context, event) => {
                // console.log("ACTION_EVENT", event.type)
                const session = localStorage.getItem("session")
                const sessionObj = session && JSON.parse(session)
                // axios
                //     .post(
                //         `${process.env.REACT_APP_QUORINI_API}/track-action`,
                //         {
                //             eventName: event.type,
                //             sessionId: context.sessionId,
                //         },
                //         {
                //             headers: { Authorization: sessionObj?.accessToken },
                //         }
                //     )
                //     .then((resp) => {
                //         // console.log("ACTION_EVENT_SAVED", event.type)
                //     })
                //     .catch((e) => {
                //         console.error(e)
                //     })
            },
            setSubObjectForm: DesignerModel.assign({
                subObjectForm: (context, event) => {
                    if (event.type !== "SUBOBJECT_FORM") return context.subObjectForm

                    if (event.subObject) {
                        return {
                            subObject: JSON.parse(JSON.stringify(event.subObject)),
                            originalSubObject: JSON.parse(JSON.stringify(event.subObject)),
                        }
                    } else {
                        return {
                            subObject: JSON.parse(JSON.stringify(DesignerModel.initialContext.subObjectForm.subObject)),
                            originalSubObject: undefined,
                        }
                    }
                },
            }),
            // Shared FieldForm actions -----------------------------------------------------------
            changeFieldName: DesignerModel.assign({
                fieldForm: (context, event) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    let cleanFieldName = cleanInputNameStartingLower(event.fieldName)

                    // check existing field name
                    if (
                        context.fieldForm.originalField?.name !== cleanFieldName &&
                        (context.entityForm.entity.fields.find((field) => field.name === cleanFieldName) !== undefined ||
                            context.userForm.user.userData.fields.find((field) => field.name === cleanFieldName) !== undefined)
                    )
                        cleanFieldName += "Duplicate"

                    let fieldNewValue = { ...context.fieldForm.field, name: cleanFieldName }
                    if (
                        context.fieldForm.field.connectionUnderlyingField &&
                        ["CONNECTION_BELONGSTO", "CONNECTION_CONTAINS"].includes(context.fieldForm.field.type)
                    )
                        fieldNewValue = {
                            ...fieldNewValue,
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            connectionUnderlyingField: {
                                ...fieldNewValue.connectionUnderlyingField,
                                name: cleanFieldName + "Id",
                            },
                        }

                    return {
                        ...context.fieldForm,
                        field: fieldNewValue,
                    }
                },
            }),
            resetField: DesignerModel.assign({
                fieldForm: (context) => {
                    if (!context.fieldForm.originalField)
                        return {
                            field: JSON.parse(JSON.stringify(DesignerModel.initialContext.fieldForm.field)),
                            originalField: undefined,
                        }
                    else return { ...context.fieldForm, field: context.fieldForm.originalField }
                },
            }),
            changeFieldDescription: DesignerModel.assign({
                fieldForm: (context, event) => ({
                    ...context.fieldForm,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    field: { ...context.fieldForm.field, description: event.description },
                }),
            }),
            changeFieldType: DesignerModel.assign({
                fieldForm: (context, event) => {
                    if (event.type !== "CHANGE_FIELD_TYPE") return context.fieldForm

                    const updField: EntityField = {
                        ...context.fieldForm.field,
                        connectionUnderlyingField: undefined,
                    }

                    updField.mandatory = false
                    updField.isArray = false
                    updField.mutable = true
                    if (event.typeValue.includes("__user__")) {
                        updField.type = "CONNECTION_BELONGSTO"
                        updField.connectedEntityName = event.typeValue.split("__user__")[1]
                        updField.connectionUnderlyingField = {
                            name: context.fieldForm.field.name ? context.fieldForm.field.name + "Id" : "",
                            type: "USER_ID",
                            mandatory: false,
                            isArray: false,
                            mutable: true,
                            remoteEntityConnectionFieldName: "_id",
                        }
                        delete updField.enumName
                        delete updField.subObjectName
                        delete updField.mandatory
                        delete updField.isArray
                        delete updField.mutable
                    } else if (event.typeValue.includes("__entity__")) {
                        updField.type = "CONNECTION_BELONGSTO"
                        updField.connectedEntityName = event.typeValue.split("__entity__")[1]
                        updField.connectionUnderlyingField = {
                            name: context.fieldForm.field.name ? context.fieldForm.field.name + "Id" : "",
                            type: "OBJECT_ID",
                            mandatory: false,
                            isArray: false,
                            mutable: true,
                            remoteEntityConnectionFieldName: "_id",
                        }
                        delete updField.enumName
                        delete updField.subObjectName
                        delete updField.mandatory
                        delete updField.isArray
                        delete updField.mutable
                    } else if (event.typeValue.includes("__subObject__")) {
                        updField.type = "SUBOBJECT"
                        updField.subObjectName = event.typeValue.split("__subObject__")[1]
                        delete updField.connectedEntityName
                        delete updField.enumName
                    } else if (event.typeValue.includes("__enum__")) {
                        updField.type = "ENUM"
                        updField.enumName = event.typeValue.split("__enum__")[1]
                        delete updField.connectedEntityName
                        delete updField.subObjectName
                    } else {
                        updField.type = event.typeValue
                        delete updField.enumName
                        delete updField.connectedEntityName
                        delete updField.subObjectName
                    }

                    return {
                        ...context.fieldForm,
                        field: updField,
                    }
                },
            }),
            switchMandatory: DesignerModel.assign({
                fieldForm: (context) => ({
                    ...context.fieldForm,
                    field: { ...context.fieldForm.field, mandatory: !context.fieldForm.field.mandatory },
                }),
            }),
            switchIsArray: DesignerModel.assign({
                fieldForm: (context) => ({
                    ...context.fieldForm,
                    field: { ...context.fieldForm.field, isArray: !context.fieldForm.field.isArray },
                }),
            }),
            switchMutable: DesignerModel.assign({
                fieldForm: (context) => ({
                    ...context.fieldForm,
                    field: { ...context.fieldForm.field, mutable: !context.fieldForm.field.mutable },
                }),
            }),
            changeConnectionUnderlyingFieldName: DesignerModel.assign({
                fieldForm: (context, event) => {
                    // remove spaces, special characters, numbers and keep only letters in field name
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const fieldNameArr = event.fieldName.split(" ")
                    for (const en in fieldNameArr) {
                        // remove spaces, special characters, numbers and keep only letters
                        fieldNameArr[en] = fieldNameArr[en].replace(/[^a-zA-Z]/g, "")
                        // set each word first letter to uppercase
                        fieldNameArr[en] = fieldNameArr[en].charAt(0).toUpperCase() + fieldNameArr[en].slice(1)
                    }
                    let cleanFieldName = fieldNameArr.join("")
                    // set first letter to lowercase
                    cleanFieldName = cleanFieldName.charAt(0).toLowerCase() + cleanFieldName.slice(1)

                    // check existing field name
                    if (
                        context.fieldForm.originalField?.connectionUnderlyingField?.name !== cleanFieldName &&
                        (context.entityForm.entity.fields.find((field) => field.name === cleanFieldName) !== undefined ||
                            context.userForm.user.userData.fields.find((field) => field.name === cleanFieldName) !== undefined)
                    )
                        cleanFieldName += "Duplicate"

                    if (context.fieldForm.field.name === cleanFieldName) cleanFieldName += "Underlying"

                    return {
                        ...context.fieldForm,
                        field: {
                            ...context.fieldForm.field,
                            connectionUnderlyingField: {
                                ...context.fieldForm.field.connectionUnderlyingField!,
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                name: event.fieldName,
                            },
                        },
                    }
                },
            }),
            setRemoteFieldName: DesignerModel.assign({
                fieldForm: (context, event) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    return {
                        ...context.fieldForm,
                        field: {
                            ...context.fieldForm.field,
                            connectionUnderlyingField: {
                                ...context.fieldForm.field.connectionUnderlyingField!,
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                remoteEntityConnectionFieldName: event.fieldName,
                            },
                        },
                    }
                },
            }),
            switchUnderlyingMandatory: DesignerModel.assign({
                fieldForm: (context) => ({
                    ...context.fieldForm,
                    field: {
                        ...context.fieldForm.field,
                        connectionUnderlyingField: {
                            ...context.fieldForm.field.connectionUnderlyingField!,
                            mandatory: !context.fieldForm.field.connectionUnderlyingField!.mandatory,
                        },
                    },
                }),
            }),
            switchUnderlyingIsArray: DesignerModel.assign({
                fieldForm: (context) => ({
                    ...context.fieldForm,
                    field: {
                        ...context.fieldForm.field,
                        connectionUnderlyingField: {
                            ...context.fieldForm.field.connectionUnderlyingField!,
                            isArray: !context.fieldForm.field.connectionUnderlyingField!.isArray,
                        },
                    },
                }),
            }),
            switchUnderlyingMutable: DesignerModel.assign({
                fieldForm: (context) => ({
                    ...context.fieldForm,
                    field: {
                        ...context.fieldForm.field,
                        connectionUnderlyingField: {
                            ...context.fieldForm.field.connectionUnderlyingField!,
                            mutable: !context.fieldForm.field.connectionUnderlyingField!.mutable,
                        },
                    },
                }),
            }),
            // End of shared FieldForm actions ------------------------------------------------
            // Shared PermissionForm actions --------------------------------------------------
            openPermissionsForm: DesignerModel.assign({
                accessForm: (context, event) => {
                    const conditionsTypes: string[] = []
                    if (event.type !== "PERMISSION_FORM") return context.accessForm

                    if (event.accessItem?.rule?.andConditions) {
                        let userConfig
                        if (event.accessItem.userGroupName) {
                            userConfig = context.projectConfig.users.find((u) => u.groupName === event.accessItem.userGroupName)
                        }

                        for (const c of event.accessItem.rule.andConditions) {
                            // Easy way to get type by user value for normal andCondition and USER_CONST andCondition
                            const typeByUserValue = userConfig?.userData.fields.find(
                                (f) => f.connectionUnderlyingField?.name == c.userAccessValue || f.name === c.userAccessValue
                            )
                            if (typeByUserValue) {
                                conditionsTypes.push(typeByUserValue.type)
                                continue
                            }

                            // get user/entity and then get types for each condition using currently selected entity/user
                            let fws = c.objectFieldRoute

                            if (!fws.fieldName) continue
                            let parentField = context.userForm.user.userData.fields.find(
                                (f) => f.name === fws.fieldName || f.connectionUnderlyingField?.name === fws.fieldName
                            )
                            // console.log(JSON.stringify({ PARENT_FIELD_user: parentField }))
                            if (parentField && !fws.subfield) {
                                conditionsTypes.push(parentField.connectionUnderlyingField?.type ?? parentField.type)
                                continue
                            }

                            if (!parentField) {
                                parentField = context.entityForm.entity.fields.find(
                                    (f) => f.name === fws.fieldName || f.connectionUnderlyingField?.name === fws.fieldName
                                )
                                // console.log(JSON.stringify({ PARENT_FIELD_entity: parentField }))
                                if (parentField && !fws.subfield) {
                                    conditionsTypes.push(parentField.connectionUnderlyingField?.type ?? parentField.type)
                                    continue
                                }
                            }

                            if (!parentField) {
                                if (Object.keys(context.userForm.user.userData.defaultFields).includes(fws.fieldName)) {
                                    conditionsTypes.push(
                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        // @ts-ignore
                                        context.userForm.user.userData.defaultFields[fws.fieldName]
                                    )
                                } else if (Object.keys(context.entityForm.entity.defaultFields).includes(fws.fieldName)) {
                                    conditionsTypes.push(
                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        // @ts-ignore
                                        context.entityForm.entity.defaultFields[fws.fieldName]
                                    )
                                } else {
                                    conditionsTypes.push("")
                                }
                                continue
                            }

                            // Process nested fields using project config
                            if (fws.subfield) {
                                fws = fws.subfield
                                while (true) {
                                    let entityData
                                    if (parentField?.type === "SUBOBJECT") {
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        parentField = context.projectConfig.subObjects![parentField!.subObjectName!].fields.find(
                                            (f) => f.name === fws.fieldName
                                        )
                                    } else if (parentField?.type && ["CONNECTION_CONTAINS", "CONNECTION_BELONGSTO"].includes(parentField!.type)) {
                                        entityData = context.projectConfig.entities.find((e) => e.entityName === parentField!.connectedEntityName)
                                        if (!entityData)
                                            entityData = context.projectConfig.users.find(
                                                (u) => u.groupName === parentField?.connectedEntityName
                                            )?.userData

                                        parentField = entityData?.fields.find(
                                            (f) => f.name === fws.fieldName || f.connectionUnderlyingField?.name === fws.fieldName
                                        )
                                    }

                                    if (!fws.subfield) {
                                        if (parentField) {
                                            conditionsTypes.push(parentField.connectionUnderlyingField?.type ?? parentField.type)
                                        } else if (entityData) {
                                            // console.log(JSON.stringify({ entityData, parentField, fws }))
                                            if (Object.keys(entityData.defaultFields).includes(fws.fieldName)) {
                                                conditionsTypes.push(
                                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                    // @ts-ignore
                                                    entityData.defaultFields[fws.fieldName]
                                                )
                                            }
                                        } else {
                                            conditionsTypes.push("")
                                        }
                                        break
                                    }

                                    fws = fws.subfield
                                }
                            }
                        }
                    }

                    // console.log(JSON.stringify({ CONDITIONS_TYPES: conditionsTypes }))
                    return {
                        accessItem: event.accessItem
                            ? JSON.parse(JSON.stringify(event.accessItem))
                            : JSON.parse(JSON.stringify(DesignerModel.initialContext.accessForm.accessItem)),
                        originalAccessItem: event.accessItem ? JSON.parse(JSON.stringify(event.accessItem)) : undefined,
                        conditionsTypes,
                        accessItemIndex: event.accessItemIndex ?? -1,
                    }
                },
            }),
            addCondition: DesignerModel.assign({
                accessForm: (context, event) => {
                    if (event.type !== "ADD_CONDITION") return context.accessForm

                    const andConditions = context.accessForm.accessItem.rule?.andConditions || []
                    const conditionsTypes = context.accessForm.conditionsTypes || []
                    conditionsTypes.push("")

                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            rule: {
                                ...context.accessForm.accessItem.rule,
                                type: "AND",
                                andConditions: [
                                    ...andConditions,
                                    {
                                        type: event.conditionType,
                                        objectFieldRoute: {
                                            fieldName: "",
                                        },
                                        userAccessValue: "",
                                    },
                                ],
                            },
                        },
                        conditionsTypes,
                    }
                },
            }),
            setUserGroupName: DesignerModel.assign({
                accessForm: (context, event) => {
                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            userGroupName: event.groupName,
                            type: "USERGROUP",
                            apiKeyName: undefined,
                        },
                    }
                },
            }),
            switchRestriction: DesignerModel.assign({
                accessForm: (context) => {
                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            rule: {
                                ...context.accessForm.accessItem.rule,
                                type: context.accessForm.accessItem.rule?.type === "AND" ? "ANY" : "AND",
                                andConditions:
                                    context.accessForm.accessItem.rule?.type === "AND"
                                        ? undefined
                                        : [
                                              {
                                                  objectFieldRoute: {
                                                      fieldName: "",
                                                  },
                                                  userAccessValue: "",
                                                  constValue: "",
                                                  type: ["PUBLIC", "AUTH"].includes(context.accessForm.accessItem.type) ? "OBJECT_CONST" : undefined,
                                              },
                                          ],
                            },
                        },
                        conditionsTypes: context.accessForm.accessItem.rule?.type === "AND" ? [] : [""],
                    }
                },
            }),
            selectAndConditionObjectField: DesignerModel.assign({
                accessForm: (context, event) => {
                    if (event.type !== "SELECT_ANDCONDITION_OBJECT_FIELD") return context.accessForm

                    const andConditions = context.accessForm.accessItem.rule!.andConditions || []
                    const conditionsTypes = context.accessForm.conditionsTypes || []

                    if (!event.fieldName) {
                        andConditions![event.index] = {
                            ...andConditions![event.index],
                            objectFieldRoute: {
                                fieldName: "",
                            },
                        }
                        conditionsTypes[event.index] = ""
                    } else {
                        const cleanFieldName = event.fieldName.split("*")
                        conditionsTypes[event.index] = cleanFieldName[1]
                        const objectFieldArr = cleanFieldName[0].split(".")
                        const objectFieldRouteTop: FieldWithSelfAsSubfield = {
                            fieldName: objectFieldArr[0],
                        }
                        if (objectFieldArr.length > 1) {
                            let subfield: FieldWithSelfAsSubfield = {
                                fieldName: objectFieldArr[objectFieldArr.length - 1],
                            }
                            for (let i = objectFieldArr.length - 2; i > 0; i--) {
                                subfield = {
                                    fieldName: objectFieldArr[i],
                                    subfield,
                                }
                            }
                            objectFieldRouteTop.subfield = subfield
                        }
                        andConditions![event.index] = {
                            ...andConditions![event.index],
                            objectFieldRoute: objectFieldRouteTop,
                            userAccessValue: "",
                        }
                    }

                    // console.log(JSON.stringify({ UPD_CONDITIONS_TYPES: conditionsTypes }))
                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            rule: {
                                ...context.accessForm.accessItem.rule!,
                                andConditions,
                            },
                        },
                        conditionsTypes,
                    }
                },
            }),
            switchAccessFields: DesignerModel.assign({
                accessForm: (context) => {
                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            fields: context.accessForm.accessItem.fields === "ALL" ? [] : "ALL",
                        },
                    }
                },
            }),
            changeAccessType: DesignerModel.assign({
                accessForm: (context, event) => {
                    if (event.type !== "CHANGE_ACCESS_TYPE") return context.accessForm
                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            type: event.accessType,
                            userGroupName: undefined,
                            apiKeyName: undefined,
                            fields: [],
                            rule: {
                                ...context.accessForm.accessItem.rule,
                                type: "ANY",
                            },
                        },
                    }
                },
            }),
            setConstValue: DesignerModel.assign({
                accessForm: (context, event) => {
                    if (event.type !== "SET_CONST_VALUE") return context.accessForm

                    const andConditions = context.accessForm.accessItem.rule!.andConditions || []
                    andConditions![event.index] = {
                        ...andConditions![event.index],
                        constValue: event.constValue,
                    }

                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            rule: {
                                ...context.accessForm.accessItem.rule!,
                                andConditions,
                            },
                        },
                    }
                },
            }),
            deleteAccessPermission: DesignerModel.assign({
                accessForm: (context) => {
                    if (context.accessForm.accessItemIndex !== -1) {
                        const accessItems = context.accessItems
                        accessItems.splice(context.accessForm.accessItemIndex, 1)

                        return {
                            ...context.accessForm,
                            accessItems,
                        }
                    }
                    return context.accessForm
                },
            }),
            resetAccesPermission: DesignerModel.assign({
                accessForm: (context) => {
                    if (!context.accessForm.originalAccessItem)
                        return {
                            ...JSON.parse(JSON.stringify(DesignerModel.initialContext.accessForm)),
                            originalAccessItem: undefined,
                        }
                    else
                        return {
                            ...context.accessForm,
                            accessItem: context.accessForm.originalAccessItem,
                        }
                },
            }),
            saveAccessPermission: DesignerModel.assign({
                accessForm: (context) => {
                    const accessItems = context.accessItems
                    if (!context.accessForm.originalAccessItem) {
                        accessItems.push(context.accessForm.accessItem)
                    } else {
                        accessItems.splice(context.accessForm.accessItemIndex, 1, context.accessForm.accessItem)
                    }

                    return {
                        ...context.accessForm,
                        accessItems,
                    }
                },
            }),
            changeRuleName: DesignerModel.assign({
                accessForm: (context, event) => {
                    if (event.type != "CHANGE_RULE_NAME") return context.accessForm

                    const ruleNameArr = event.name.split(" ")
                    for (const en in ruleNameArr) {
                        // remove spaces, special characters, numbers and keep only letters
                        ruleNameArr[en] = ruleNameArr[en].replace(/[^a-zA-Z]/g, "")
                        // set each word first letter to uppercase
                        ruleNameArr[en] = ruleNameArr[en].charAt(0).toUpperCase() + ruleNameArr[en].slice(1)
                    }
                    const cleanRuleName = ruleNameArr.join("")

                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            rule: {
                                ...context.accessForm.accessItem.rule!,
                                name: cleanRuleName,
                            },
                        },
                    }
                },
            }),
            changeRuleDescription: DesignerModel.assign({
                accessForm: (context, event) => ({
                    ...context.accessForm,
                    accessItem: {
                        ...context.accessForm.accessItem,
                        rule: {
                            ...context.accessForm.accessItem.rule!,
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            description: event.description,
                        },
                    },
                }),
            }),
            setUserAccessValue: DesignerModel.assign({
                accessForm: (context, event) => {
                    if (event.type !== "SET_USER_ACCESS_VALUE") return context.accessForm

                    // console.log(event.userField)
                    const conditionsTypes = context.accessForm.conditionsTypes || [""]
                    if (conditionsTypes[event.index] == "") {
                        conditionsTypes[event.index] = event.userField?.split("*")[1]
                    }

                    const andConditions = context.accessForm.accessItem.rule!.andConditions
                    andConditions![event.index] = {
                        ...andConditions![event.index],
                        userAccessValue: event.userField?.split("*")[0],
                    }

                    return {
                        ...context.accessForm,
                        conditionsTypes,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            rule: {
                                ...context.accessForm.accessItem.rule!,
                                andConditions,
                            },
                        },
                    }
                },
            }),
            deleteCondition: DesignerModel.assign({
                accessForm: (context, event) => {
                    if (event.type !== "DELETE_CONDITION") return context.accessForm

                    const andConditions = context.accessForm.accessItem.rule!.andConditions || []
                    const conditionsTypes = context.accessForm.conditionsTypes || []
                    andConditions!.splice(event.index, 1)
                    conditionsTypes.splice(event.index, 1)

                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            rule: {
                                ...context.accessForm.accessItem.rule!,
                                andConditions,
                            },
                        },
                        conditionsTypes,
                    }
                },
            }),
            changeAccessField: DesignerModel.assign({
                accessForm: (context, event) => {
                    if (event.type !== "CHANGE_FIELD_ACCESS") return context.accessForm

                    const contextFields = context.accessForm.accessItem.fields as AccessField[]
                    const contextConfig = context.projectConfig
                    let contextEntityFields: EntityField[] = []
                    let defaultFields: UserDefaultFields | EntityDefaultFields = {} as UserDefaultFields

                    if (context.userForm.user.groupName !== "") {
                        contextEntityFields = context.userForm.user.userData.fields
                        defaultFields = context.userForm.user.userData.defaultFields
                    }

                    if (context.entityForm.entity.entityName !== "") {
                        contextEntityFields = context.entityForm.entity.fields
                        defaultFields = context.entityForm.entity.defaultFields
                    }

                    const fieldPath = event.fieldPath.split(".")
                    const allAvailableAccessFields = getAllAccessFields(contextConfig, contextEntityFields)
                    // Create the merged array
                    const mergedFields = allAvailableAccessFields.map((field) => {
                        const match = contextFields.find((contextField) => isFieldsMatch(contextField, field))
                        return match ? match : field
                    })

                    // Add contextFields that are not in allFields
                    const unmatchedContextFields = contextFields.filter((contextField) => {
                        return !allAvailableAccessFields.some((field) => isFieldsMatch(contextField, field))
                    })

                    // Combine the arrays
                    const allContextFields = [...unmatchedContextFields, ...mergedFields]

                    const fieldIndex = allContextFields.findIndex((cf: AccessField | undefined) => {
                        for (let i = 0; i < fieldPath.length; i++) {
                            if ((!cf?.subfield && i < fieldPath.length - 1) || cf?.fieldName !== fieldPath[i]) return false

                            cf = cf?.subfield
                        }
                        return true
                    })

                    // DELETE all fields handler
                    if (event.fieldPath === "ALL_FIELDS" && event.accessType === "DELETE") {
                        const entityDefaultFields = Object.keys(defaultFields).map(
                            (name) =>
                                ({
                                    name,
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    type: defaultFields[name],
                                }) as EntityField
                        )
                        const allFields = entityDefaultFields.concat(contextEntityFields)
                        if (allContextFields.filter((field) => field.operations?.includes("DELETE")).length === allFields.length) {
                            for (const af of allFields) {
                                const fInd = allContextFields.findIndex(
                                    (f) => f.fieldName === af.name || af.connectionUnderlyingField?.name === f.fieldName
                                )
                                const opInd = allContextFields[fInd].operations!.findIndex((o) => o === event.accessType)
                                if (opInd !== -1) {
                                    if (allContextFields[fInd].operations!.length === 1) {
                                        allContextFields.splice(fInd, 1)
                                    } else {
                                        allContextFields[fInd].operations!.splice(opInd, 1)
                                    }
                                }
                            }
                        } else {
                            for (const af of allFields) {
                                const fInd = allContextFields.findIndex(
                                    (f) => f.fieldName === af.name || af.connectionUnderlyingField?.name === f.fieldName
                                )
                                if (fInd !== -1) {
                                    if (!allContextFields[fInd].operations!.includes(event.accessType as Operation))
                                        allContextFields[fInd].operations!.push(event.accessType as Operation)
                                } else {
                                    allContextFields.push({
                                        fieldName: af.connectionUnderlyingField?.name ?? af.name,
                                        operations: [event.accessType as Operation],
                                    })
                                }
                            }
                        }
                        return {
                            ...context.accessForm,
                            accessItem: {
                                ...context.accessForm.accessItem,
                                fields: allContextFields.filter((field) => field.operations && field.operations.length !== 0),
                            },
                        }
                    }
                    // end of DELETE all fields handler

                    if (fieldIndex === -1) {
                        // Add new field with new permission
                        let newField: AccessField = {
                            fieldName: fieldPath[fieldPath.length - 1],
                        }
                        for (let i = fieldPath.length - 2; i >= 0; i--) {
                            newField = {
                                fieldName: fieldPath[i],
                                subfield: newField,
                            }
                        }
                        if (newField.subfield) {
                            if (event.accessType === "CREATE" && isMandatoryField(contextConfig, contextEntityFields, newField)) {
                                const getMandatorySubObjNames = getSubMandatoryFieldNames(contextConfig, contextEntityFields, newField.fieldName)
                                const getMandatoryAccessFields = getMandatoryAccessFieldsOfParentField(
                                    allContextFields,
                                    contextConfig,
                                    contextEntityFields,
                                    newField
                                )
                                if (getMandatoryAccessFields.length !== getMandatorySubObjNames.length) {
                                    const missedMandatoryFieldsNames = getMandatorySubObjNames.filter(
                                        (son) => !getMandatoryAccessFields.map((fr) => fr.fieldName).includes(son)
                                    )
                                    if (missedMandatoryFieldsNames.length > 0) {
                                        missedMandatoryFieldsNames.forEach((mf) => {
                                            allContextFields.push({
                                                fieldName: newField.fieldName,
                                                subfield: { fieldName: mf },
                                                operations: ["CREATE"],
                                            })
                                        })
                                    }
                                }
                            } else {
                                allContextFields.push({
                                    ...newField,
                                    operations: [event.accessType as Operation],
                                })
                            }
                        } else {
                            allContextFields.push({
                                ...newField,
                                operations: [event.accessType as Operation],
                            })
                        }
                    } else {
                        const targetField = allContextFields[fieldIndex]
                        const entityField = getEntityField(contextEntityFields, targetField)

                        if (targetField.operations?.includes(event.accessType as Operation)) {
                            // Remove operation for particular fields
                            if (isMandatoryField(contextConfig, contextEntityFields, targetField)) {
                                if (event.accessType === "CREATE") {
                                    if (entityField.mandatory === true) {
                                        removeOperationAllFields(allContextFields, event.accessType as Operation)
                                    } else if (entityField.mandatory === false) {
                                        removeOperationAllFields(
                                            getAllAccessFieldsOfParentField(allContextFields, contextConfig, contextEntityFields, targetField),
                                            event.accessType as Operation
                                        )
                                    } else if (entityField.mandatory === undefined) {
                                        if (entityField.connectionUnderlyingField?.mandatory) {
                                            removeOperationAllFields(allContextFields, event.accessType as Operation)
                                        } else {
                                            removeOperationAllFields([targetField], event.accessType as Operation)
                                        }
                                    }
                                } else {
                                    removeOperationAllFields([targetField], event.accessType as Operation)
                                }
                            } else {
                                targetField.operations = targetField?.operations.filter((operation) => operation !== event.accessType)
                            }
                        } else {
                            // Set Operation for particular fields
                            if (isMandatoryField(contextConfig, contextEntityFields, targetField)) {
                                if (event.accessType === "CREATE") {
                                    if (fieldsWithOperation(allContextFields, event.accessType).length === 0) {
                                        setOperationAllFields(
                                            allContextFields.filter((field) => {
                                                if (getEntityField(contextEntityFields, field)?.mandatory) {
                                                    if (isMandatoryField(contextConfig, contextEntityFields, field)) {
                                                        return field
                                                    }
                                                } else if (getEntityField(contextEntityFields, field)?.connectionUnderlyingField?.mandatory) {
                                                    if (isMandatoryField(contextConfig, contextEntityFields, field)) {
                                                        return field
                                                    }
                                                }
                                            }),
                                            event.accessType as Operation
                                        )
                                        targetField.operations!.push(event.accessType as Operation)
                                        setOperationAllFields(
                                            getMandatoryAccessFieldsOfParentField(allContextFields, contextConfig, contextEntityFields, targetField),
                                            event.accessType as Operation
                                        )
                                    } else {
                                        if (entityField.mandatory) {
                                            setOperationAllFields(
                                                allContextFields.filter((field) => {
                                                    if (getEntityField(contextEntityFields, field)?.mandatory) {
                                                        if (isMandatoryField(contextConfig, contextEntityFields, field)) {
                                                            return field
                                                        }
                                                    } else if (getEntityField(contextEntityFields, field)?.connectionUnderlyingField?.mandatory) {
                                                        if (isMandatoryField(contextConfig, contextEntityFields, field)) {
                                                            return field
                                                        }
                                                    }
                                                }),
                                                event.accessType as Operation
                                            )
                                        } else {
                                            setOperationAllFields(
                                                getMandatoryAccessFieldsOfParentField(
                                                    allContextFields,
                                                    contextConfig,
                                                    contextEntityFields,
                                                    targetField
                                                ),
                                                event.accessType as Operation
                                            )
                                        }
                                    }
                                } else {
                                    setOperationAllFields([targetField], event.accessType as Operation)
                                }
                            } else {
                                if (event.accessType === "CREATE") {
                                    if (fieldsWithOperation(allContextFields, event.accessType).length === 0) {
                                        setOperationAllFields(
                                            allContextFields.filter((field) => {
                                                if (getEntityField(contextEntityFields, field)?.mandatory) {
                                                    if (isMandatoryField(contextConfig, contextEntityFields, field)) {
                                                        return field
                                                    }
                                                } else if (getEntityField(contextEntityFields, field)?.connectionUnderlyingField?.mandatory) {
                                                    if (isMandatoryField(contextConfig, contextEntityFields, field)) {
                                                        return field
                                                    }
                                                }
                                            }),
                                            event.accessType as Operation
                                        )
                                        targetField.operations!.push(event.accessType as Operation)
                                        setOperationAllFields(
                                            getMandatoryAccessFieldsOfParentField(allContextFields, contextConfig, contextEntityFields, targetField),
                                            event.accessType as Operation
                                        )
                                    } else {
                                        targetField.operations!.push(event.accessType as Operation)
                                    }
                                } else {
                                    targetField.operations!.push(event.accessType as Operation)
                                }
                            }
                        }
                    }

                    return {
                        ...context.accessForm,
                        accessItem: {
                            ...context.accessForm.accessItem,
                            fields: allContextFields.filter((field) => field.operations && field.operations.length !== 0),
                        },
                    }
                },
            }),
            // End of shared PermissionForm actions -------------------------------------------
        },

        services: {
            getProject: (ctx) => (send) => {
                const session = localStorage.getItem("session")
                const sessionObj = session && JSON.parse(session)

                axios
                    .get(`${process.env.REACT_APP_QUORINI_API}/get-project/${ctx.projectId}`, {
                        headers: {
                            Authorization: sessionObj?.accessToken,
                        },
                    })
                    .then((resp) => {
                        // console.log(resp)
                        send({ type: "FETCHED", project: resp.data })
                    })
                    .catch((e) => {
                        console.error(e)
                        send("ERROR")
                    })
            },
            saveConfig: (ctx) => (send) => {
                const session = localStorage.getItem("session")
                const sessionObj = session && JSON.parse(session)

                axios
                    .post(`${process.env.REACT_APP_QUORINI_API}/${ctx.projectId}/save-config`, ctx.projectConfig as Config, {
                        headers: { Authorization: sessionObj?.accessToken },
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            send({
                                type: "SAVED",
                                configId: response.data._id,
                                configSaveResult: response.data,
                                msg: "Successfully saved version changes!",
                            })
                            ctx.notificationsApi?.success({
                                message: "Saved version",
                                description: "Successfully saved version changes!",
                                placement: "bottomLeft",
                                duration: 5,
                            })
                        } else {
                            throw new Error("Failed saving config, try again...")
                        }
                    })
                    .catch((e) => {
                        console.error(e)
                        send("ERROR")
                        ctx.notificationsApi?.error({
                            message: "Error",
                            description: "Failed saving project, try again...",
                            placement: "bottomLeft",
                            duration: 5,
                        })
                    })
            },
            deployConfig: (ctx) => (send) => {
                const session = localStorage.getItem("session")
                const sessionObj = session && JSON.parse(session)

                axios
                    .post(
                        `${process.env.REACT_APP_QUORINI_API}/${ctx.projectId}/${ctx.projectConfig._id}/deploy`,
                        {},
                        {
                            headers: {
                                Authorization: sessionObj?.accessToken,
                            },
                        }
                    )
                    .then((resp) => {
                        send({ type: "DEPLOYED", configDeployResult: resp.data })
                        ctx.notificationsApi?.success({
                            message: "Deployed project",
                            description: "Your project version was successfully deployed!",
                            placement: "bottomLeft",
                            duration: 5,
                        })
                    })
                    .catch((e) => {
                        console.error(e)
                        send("ERROR")
                        ctx.notificationsApi?.error({
                            message: "Error",
                            description: "Failed to deploy project version, try again...",
                            placement: "bottomLeft",
                            duration: 5,
                        })
                    })
            },
        },
    }
)
